import React, { Fragment, useEffect, useState } from 'react';
import PropTypes from 'prop-types';

// Firebase
import { db } from '../config/firebase-config';
import { collection, getDocs, getDoc, addDoc, updateDoc, doc, setDoc, deleteDoc, query, where, onSnapshot, orderBy, startAfter, limit } from 'firebase/firestore';

import mixpanel from 'mixpanel-browser';

// Redux
import { connect } from 'react-redux';

// Actions
import { setPage, add_To_Recent_History, toggleAuthModal, toggleCreateSportsMatchModal } from '../actions/navActions';

// Layout Wrapper
import Layout from '../components/layout/Layout';
import Spinner from '../components/common/Spinner';
import replaceHyphenWithSpace from '../utils/reusable_functions/replace_Hyphens_With_Space';
import SportsBlock from '../components/Sports/SportsBlock';
import { getMatchesBySportType, set_ShowBottomSpinner } from '../actions/sportsMatchActions';

// Icons
import AddIcon from '@material-ui/icons/Add';
import { setAlert } from '../actions/alertActions';

const FullSchedule = ({ 
    setPage, 
    add_To_Recent_History,
    match, 
    sport: {
      matches, 
      no_more_matches,
      loading,
      show_bottom_spinner,
      last_page_doc
    },
    auth,
    nav: {
        website,
        website_loading
    },
    getMatchesBySportType,
    set_ShowBottomSpinner,
    setAlert,
    toggleCreateSportsMatchModal
}) => {

    // State variable to track if Mixpanel event has been sent
    const [sentMixpanel, setSentMixpanel] = useState(false);

    // Window width
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);

    // Check if website is custom url or main website
    const [checked_WebsiteType, setChecked_WebsiteType] = useState(false);

    // -- Inifite scroll --

    // Temporarily disable to load more function to avoid duplicate fetch requests
    const [canLoadMore, setCanLoadMore] = useState(true);
    // Scroll direction - for displaying top nav bar
    const [scrollDirection, setScrollDirection] = useState("up");
    const [oldScrollY, setOldScrollY] = useState(window.scrollY);

    // -- END: Inifite scroll --

    const [groupsList, setGroupsList] = useState([]);

    // Get the current URL and extract the "redirect" parameter
    const url_filter = (window.location.href);
    const url = new URL(url_filter);
    const hostname = window.location.hostname;
    const url_sport_type = match.params.sport_type?.toLowerCase();

    // Determine window size breakpoints
    const isMobile = windowWidth <= 769;
    const isTablet = windowWidth <= 1000;

    // Listen for window resize event and update window width state
    useEffect(() => {

        // Set the current page to 'likes'
        setPage('full schedule');
        add_To_Recent_History(url.pathname);  // current url

        // Add event listener for window resize
        window.addEventListener('resize', () => handleWindowSizeChange());

        // Clean up by removing event listener on component unmount
        return () => window.removeEventListener('resize', () => handleWindowSizeChange());
    }, []);

    // Update window width state on window resize
    const handleWindowSizeChange = () => {
        setWindowWidth(window.innerWidth);
    };

    // -- Get initial groups list --

    useEffect(() => {
        if(url_sport_type && !website_loading) {
          getMatchesBySportType({ sport_type: url_sport_type, group_id: website?._id });
        } 

    }, [url_sport_type, website, website_loading]);

    // -- END: Get initial groups list --

    useEffect(() => {

        renderGroupList();

    }, [ matches, loading, canLoadMore ]);

    // Handle top nav bar display
    const handleScroll = (e) => {
        const { offsetHeight, scrollTop, scrollHeight } = e.target

        const newScrollY = offsetHeight + scrollTop;

        // --- Handle top nav bar display
        if(isMobile) {
            if(oldScrollY < newScrollY){

                // scrolling down - hide top nav
                setScrollDirection("down");
    
                if(document.getElementById('feed-header') !== null) {
                    document.getElementById('feed-header').classList.remove("active");
                }
                
            } else {
    
                // scrolling up - show top nav
                setScrollDirection("up");
    
                if(document.getElementById('feed-header') !== null) {
                    document.getElementById('feed-header').classList.add("active");
                }
            }
        }
        // --- END Handle top nav bar display

        // update the scroll position for future comparison
        setOldScrollY(newScrollY)

        // Check if the user has scrolled to the bottom of the content and conditions for loading more notifications are met
        if (newScrollY >= scrollHeight - 1 && !show_bottom_spinner && !no_more_matches && matches.length > 0 && canLoadMore) {
            console.log('scrolling');
            // loadMore();
        }
    }

    // Function to load more paginated notifications
    const loadMore = async () => {
        console.log('Loading more sports matches');

        try {
            // Temporarily disable to load more function to avoid duplicate fetch requests
            setCanLoadMore(false);
            // Show spinner
            set_ShowBottomSpinner(true);

            if(!website_loading) {
              if(url_sport_type) {
                await getMatchesBySportType({ sport_type: url_sport_type, group_id: website?._id, last_page_doc });
              }
            }
        } catch (error) {
            console.log("ERROR loading more", error);
        } finally {
            // Re-enable the load more capabilty
            setCanLoadMore(true);
        }

    }

    const handleCreateMatch = () => {
      if(auth.loading || website_loading) return;
      
      if(auth.user && (website?.admins?.includes(auth.user?._id) || auth.user?._id === "PyeEDPpD3JgJDhq2Vu2KoAjEViH3" || auth.user?._id === "USsW6GshdRgeyw2cgL7p7mchqeS2")) {
        toggleCreateSportsMatchModal();
      } else {
          console.log("Unable to create group - unauthorized");
          setAlert('Unable to create group - unauthorized', 'danger')
      }
    }

    // Handles Mixpanel tracking
    const handleMixpanel = () => {
        mixpanel.init(process.env.REACT_APP_MIXPANEL_ID);

        // Track event
        mixpanel.track("Full Schedule Page View");
    }

    // Checks if the environment is production and Mixpanel tracking hasn't been sent
    if(process.env.NODE_ENV === 'production' && !sentMixpanel && !hostname.includes('xbuysell')) {
        // Call Mixpanel tracking function
        handleMixpanel();
        // Set Mixpanel event as sent
        setSentMixpanel(true);
    }

    const renderGroupList = async () => {
        setGroupsList([]);

        if(loading) {
            setGroupsList([(
                <div className="no-rides">
                    <Spinner />
                </div>
            )])
        }
        else { 
            if(matches.length > 0) {
                matches.map(match_info => {
                    setGroupsList(matchesList => [...matchesList, (
                      <SportsBlock match_info={match_info} />
                    )])
                }) 
            } else {
                setGroupsList(matchesList => [...matchesList, (
                    <div className="no-rides">
                        <h1>No matches found</h1>
                    </div>
                )])
                
            }
        } 
    }

    // Check if website is custom url or main website (this page is only for custom URLs)
    if(!website_loading && !website && !checked_WebsiteType) {
        // window.location.href = '/home';

        setChecked_WebsiteType(true);
    }

    return (
        <Fragment>
            <Layout handleScroll={handleScroll} page="full schedule" page_title={replaceHyphenWithSpace(url_sport_type)}>
                
                {(website?.admins?.includes(auth.user?._id) || auth.user?._id === "PyeEDPpD3JgJDhq2Vu2KoAjEViH3" || auth.user?._id === "USsW6GshdRgeyw2cgL7p7mchqeS2") && (
                  <div style={{width: '100%', padding: '16px', boxSizing: 'border-box'}}>
                    <div onClick={handleCreateMatch} className='see_more_btn full_width blue'>
                        Create a new match
                        <div style={{width: '5px'}}></div>
                        <AddIcon />
                    </div>
                </div>
                )}

                {/* spacer */}
                <div style={{height: '5px'}}></div>
                {groupsList}

                {/* Render a spinner at the bottom if there are more notifications to load */}
                {show_bottom_spinner && !no_more_matches && !loading && <Spinner />}

                {/* Display a message when there are no more notifications */}
                <div className="no-rides" style={{minHeight: '400px', justifyContent: 'start', paddingTop: '50px'}}>{(no_more_matches && matches.length !== 0) && "You've reached the end."}</div>
            </Layout>
        </Fragment>
    )
}

FullSchedule.propTypes = {
    auth: PropTypes.object.isRequired,
    nav: PropTypes.object.isRequired,
    sport: PropTypes.object.isRequired, // Object prop representing the group state
    setPage: PropTypes.func.isRequired, // Function prop to set the current page in the navigation
    add_To_Recent_History: PropTypes.func.isRequired,
    getMatchesBySportType: PropTypes.func.isRequired,
    set_ShowBottomSpinner: PropTypes.func.isRequired,
    setAlert: PropTypes.func.isRequired,
    toggleCreateSportsMatchModal: PropTypes.func.isRequired,
}

const mapStateToProps = state => ({

    // Mapping the states from the Redux store to the below props
    sport: state.sport,
    auth: state.auth,
    nav: state.nav
});

export default connect(mapStateToProps, { 

    // Connecting actions to the component
    setPage, 
    add_To_Recent_History,
    getMatchesBySportType,
    set_ShowBottomSpinner,
    setAlert,
    toggleCreateSportsMatchModal
})(FullSchedule);
